/**
 * Cloudinary URL helpers.
 *
 * PDFs are uploaded to Cloudinary as `image` resource type, so the delivery
 * URL lives under `/image/upload/`. Appending `.pdf` returns the raw document,
 * while a `pg_1` page transformation can rasterize the first page to an image.
 */

const cloudName = import.meta.env.VITE_CLOUDINARY_CLOUDNAME as
  string | undefined;

const CLOUDINARY_BASE = 'https://res.cloudinary.com';

/** Direct URL to the raw PDF document for a given Cloudinary public id. */
export function getCloudinaryPdfUrl(publicId: string): string {
  return `${CLOUDINARY_BASE}/${cloudName}/image/upload/${publicId}.pdf`;
}

/** URL to a cropped image thumbnail for a given Cloudinary public id. */
export function getCloudinaryImageThumbnailUrl(
  publicId: string,
  { width = 200, height = 200 }: { width?: number; height?: number } = {},
): string {
  return `${CLOUDINARY_BASE}/${cloudName}/image/upload/c_fill,w_${width},h_${height},f_auto,q_auto/${publicId}`;
}

/**
 * URL to a rasterized image of the PDF's first page. Useful for thumbnails.
 * Uses `c_fit` so the whole page stays visible inside the requested bounds.
 */
export function getCloudinaryPdfThumbnailUrl(
  publicId: string,
  { width = 300, height = 300 }: { width?: number; height?: number } = {},
): string {
  return `${CLOUDINARY_BASE}/${cloudName}/image/upload/pg_1,c_fit,w_${width},h_${height},f_jpg/${publicId}.jpg`;
}
